import {Button, Windows} from '@blesk-frontend/ui';
import {AppPageWrapper} from '@/components';
import {useAppPlatform} from '@/hooks';
import {downloadAgent} from '@/libs';
export const WindowsPage = () => {
  const {windowsStatus} = useAppPlatform();
  const isNotAvailable = windowsStatus === 'not-available';

  const onClickDownload = () => {
    if (isNotAvailable) return;

    downloadAgent('windows');
  };

  return (
    <AppPageWrapper>
      <div className="mx-auto max-w-lg p-4">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col items-center gap-6">
            <Windows className="size-16" />

            <h1 className="text-center text-title-h1">
              Установите
              <br />
              Блеск для Windows
            </h1>

            <p className="text-center text-paragraph-md text-text-secondary">
              Чтобы записывать действия в приложениях и&nbsp;автоматически создавать пошаговые
              инструкции, вам необходимо установить Блеск для&nbsp;Windows.
            </p>

            <p className="text-center text-paragraph-md text-text-secondary">
              Например для 1С:Бухгалтерия, MS Office и др.
            </p>

            <div className="flex flex-col items-center">
              <Button onClick={onClickDownload} disabled={isNotAvailable}>
                Установить Блеск для Windows
              </Button>
            </div>

            <p className="text-center text-paragraph-sm text-text-secondary">
              Версия 0.7.1
              <br />
              Работает в Windows 10 и новее
            </p>
          </div>
        </div>
      </div>
    </AppPageWrapper>
  );
};
